import React, { FC, useState } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { MagicIcon } from '@modernloop/shared/icons';
import { IconButton, ListItemButton, ListItemIcon, Tooltip, Typography } from '@mui/material';

import { useIsMLoopInternalOnly } from 'src/hooks/feature-flag/useIsMLoopInternalOnly';

import DevToolsModal from './DevToolsModal';

type Props = {
  expanded: boolean;
};

const DevToolsNavButton: FC<Props> = ({ expanded }) => {
  const { t } = useTranslation();
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);

  const isMLOnly = useIsMLoopInternalOnly();
  if (!isMLOnly) {
    return null;
  }

  const handleDevToolsClick = () => {
    setIsDevToolsOpen(!isDevToolsOpen);
  };

  return (
    <>
      {!expanded && (
        <Tooltip title={t('hiring-dashboard-dev-tools:dev-tools.internalOnlyTooltip')}>
          <IconButton id="app-nav-dev-tools" data-testid="app-nav-dev-tools" onClick={handleDevToolsClick}>
            <MagicIcon />
          </IconButton>
        </Tooltip>
      )}
      {expanded && (
        <ListItemButton id="app-nav-dev-tools" data-testid="app-nav-dev-tools" onClick={handleDevToolsClick}>
          <ListItemIcon>
            <MagicIcon />
          </ListItemIcon>
          <Typography color="text.secondary" fontWeight="500" variant="body2">
            {t('hiring-dashboard-dev-tools:dev-tools.title')}
          </Typography>
        </ListItemButton>
      )}
      {isDevToolsOpen && <DevToolsModal onClose={handleDevToolsClick} />}
    </>
  );
};

export default DevToolsNavButton;
